import { planningAPI } from "../../axios";

export const actions = {
    //Planning Template API
    GetPlanningTemplateApi(context, data){
        return planningAPI.get(`PlanningTemplateApi/PlanningTemplateDeliveryUnit/${data}`);
    },
    GetSinglePlanningTemplateApi(context, data){
        return planningAPI.get(`PlanningTemplateApi/${data}`);
    },
    UpdatePlanningTemplateApi(context, data){
        return planningAPI.put(`PlanningTemplateApi/Update/${data.id}`, data);
    },
    DeletePlanningTemplateApi(context, data){
        return planningAPI.delete(`PlanningTemplateApi/Remove/${data}`);
    },
    CreatePlanningTemplateApi(context, data){
        return planningAPI.post(`PlanningTemplateApi/Add`, data);
    },
}